import { __ } from '@wordpress/i18n';
import { TextControl, TextareaControl, ToggleControl } from "@wordpress/components";
import { produce } from 'immer';
import { InlineDetailMediaUpload, Label } from '../../../../../bpl-tools/Components';
import { BControlPro } from '../../../../../bpl-tools/ProControls';

const Item = ({ attributes, setAttributes, arrKey, index, setActiveIndex = false, premiumProps }) => {
    const { sourceType } = attributes;
    const sliders = attributes[arrKey];
    const { title, img, video, desc, btnLabel, btnUrl, target, altText, } = sliders[index];

    const updateSlider = (type, val, childType = false) => {
        const newSlider = produce(sliders, draft => {
            if (childType) {
                draft[index][type][childType] = val;
            } else {
                draft[index][type] = val;
            }
        });
        setAttributes({ sliders: newSlider });
    }

    return <>
        <div key={index} className="components_button_main" onClick={() => setActiveIndex(index)}>
            <Label className="mt10" >{__('Slide', 'slider')} {sourceType === 'video' ? 'Video' : 'Image'}</Label>

            {sourceType === 'video' && <InlineDetailMediaUpload className='mt10' value={video} types={['video']} onChange={val => updateSlider('video', val)} placeholder={__('Enter Video URL', 'slider')} />}

            <InlineDetailMediaUpload label={`${sourceType === 'video' ? 'Poster Url' : ''}`} value={img} types={['image']} onChange={val => updateSlider('img', val)} placeholder={__('Enter Image URL', 'slider')} />

            {(sourceType !== 'posts' && sourceType !== 'woo' && sourceType !== 'video') && <>
                <TextControl label={__("Image Alt", 'slider')} labelPosition={__('top', 'slider')} value={altText != null ? altText : img?.caption || img?.title} placeholder={__('Enter Image Alt Text', 'slider')} onChange={val => updateSlider('altText', val)} />

                <TextControl label={__("Title", 'slider')} labelPosition={__('top', 'slider')} value={title != null ? title : img?.caption || img?.title} placeholder={__('Enter Title', 'slider')} onChange={val => updateSlider('title', val)} />

                <TextareaControl label={__("Description", 'slider')} labelPosition={__('top', 'slider')} value={desc} placeholder={__('Enter desc', 'slider')} onChange={val => updateSlider('desc', val)} />

                <BControlPro label={__("Button label", 'slider')} labelPosition={__('top', 'slider')} value={btnLabel} placeholder={__('Enter Label', 'slider')} onChange={val => updateSlider('btnLabel', val)} Component={TextControl} {...premiumProps} />

                <BControlPro label={__("Button Url", 'slider')} labelPosition={__('top', 'slider')} value={btnUrl} placeholder={__('Enter Url', 'slider')} onChange={val => updateSlider('btnUrl', val)} Component={TextControl} {...premiumProps} />

                <BControlPro className='mt20' label={__('Open in new tab', 'slider')} checked={target} onChange={(val) => updateSlider('target', val)} Component={ToggleControl} {...premiumProps} />
            </>}
        </div>
    </>
}
export default Item;